export const card = {
  root: {
    background: "{content.background}",
    borderRadius: "{content.border.radius}",
    color: "{content.color}",
    shadow: "none",
  },
  body: {
    padding: "{padding.16}",
    gap: "{gap.16}",
  },
  caption: {
    gap: "{gap.16}",
  },
  title: {
    fontSize: "{typography.accordion.heading.font.size}",
    fontWeight: "{typography.accordion.heading.font.weight}",
  },
  subtitle: {
    color: "{text.subtle-text}",
  },
  extend: {
    ui: {
      root: {
        borderColor: "{content.border.color}",
        borderWidth: "{border.width.1}",
        gap: "{gap.16}",
      },
    },
  },
  css: ({ dt }: any): string => `
    :has(> p-card + p-card) {
      display: flex;
      flex-direction: column;
      gap: ${dt("card.ui.gap")};
    }

    .p-card {
      border-style: solid;
      border-color: ${dt("card.ui.border.color")};
      border-width: ${dt("card.ui.border.width")};
    }

    .card-grow {
      .p-card-body {
        height: 100%;
      }
      .p-card-content {
        flex: 1;
        overflow: auto;
      }
    }
  `,
};
